// removed by extract-text-webpack-plugin
module.exports = {"container":"_19UsJyqPdKZ1nl-ZITh-ty","icon":"_3BHYnoBpsymxHYddgvuG2o","title":"_2x-jW14fCrKsRHkuqHINV_"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Documents/Document/AnnexedDocuments/styles.css
// module id = 2882
// module chunks = 0